import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dateFrom", "dateTo"]

  apply() {
    const dateFrom = this.dateFromTarget.value
    const dateTo = this.dateToTarget.value

    if (!dateFrom && !dateTo) {
      return
    }

    const currentParams = new URLSearchParams(window.location.search)

    if (dateFrom) {
      currentParams.set('date_from', dateFrom)
    } else {
      currentParams.delete('date_from')
    }

    if (dateTo) {
      currentParams.set('date_to', dateTo)
    } else {
      currentParams.delete('date_to')
    }

    window.location.href = `${window.location.pathname}?${currentParams.toString()}`
  }
}
